<template>
  <section
    v-if="!userHasSubscription && !isBusinessUser"
    :class="[
      'premium-promo__section',
      isPremiumMonthlyPromoPage && 'premium-promo__section--premium-promo-page',
    ]"
  >
    <div class="premium-promo__content">
      <div class="premium-promo__text">
        <div class="premium-promo__text-title-enquiry">LIMITED TIME OFFER</div>
        <div class="premium-promo__text-title">Premium Monthly Subscription</div>
        <div class="premium-promo__cta">
          <router-link
            :to="{ name: 'premium-monthly' }"
            :class="[
              'btn btn--primary btn--responsive',
              isPremiumMonthlyPromoPage && 'premium-promo__cta-button--hide',
            ]"
          >
            Claim this deal
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'PremiumMonthlyPromoSection',
  components: {},
  computed: {
    ...mapState({
      usersCurrentSubscriptions: state => state.subscriptions.usersCurrentSubscriptions,
    }),
    ...mapGetters({
      isBusinessUser: 'business/isBusinessUser',
    }),
    userHasSubscription() {
      return this.usersCurrentSubscriptions.length > 0
    },
    isPremiumMonthlyPromoPage() {
      return this.$route.name === 'premium-monthly'
    },
  },
}
</script>

<style lang="scss">
.premium-promo {
  &__section {
    width: 100%;
    position: relative;
    top: -60px;
    padding: 90px 20px 150px 20px;
    margin-bottom: -150px;
    z-index: 0;
    background-image: url("data:image/svg+xml,%3Csvg width='745' height='660' viewBox='0 0 745 660' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M558.421 0H188.745L0 209.995L372.299 660L744.543 212.532L558.421 0ZM196.45 240.01L296.724 472.516L104.263 240.01H196.45ZM480.879 240.01L372.299 492.014L263.718 240.01H480.879ZM283.172 180.034L372.08 76.8855L460.934 180.034H283.172ZM547.874 240.01H641.81L447.108 474.365L547.874 240.01ZM634.542 180.034H541.645L438.529 60.0288H529.677L634.542 180.034ZM217.051 60.0288H306.069L202.625 180.034H109.181L217.051 60.0288Z' fill='url(%23paint0_linear_2983_47950)'/%3E%3Cdefs%3E%3ClinearGradient id='paint0_linear_2983_47950' x1='0.000871949' y1='545.407' x2='715.106' y2='206.178' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0.0104167' stop-color='%23AB3AD2'/%3E%3Cstop offset='0.5' stop-color='%23863AD2'/%3E%3Cstop offset='1' stop-color='%235936E4'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: 135px -15px;
    background-size: cover;
    &--premium-promo-page {
      margin-bottom: -220px;
      padding-bottom: 180px;
    }
    @include mobile {
      margin-bottom: -120px;
      background-position: 140% 55%;
      background-size: contain;
    }
    @include desktop {
      background-image: url("data:image/svg+xml,%3Csvg width='745' height='660' viewBox='0 0 745 660' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M558.421 0H188.745L0 209.995L372.299 660L744.543 212.532L558.421 0ZM196.45 240.01L296.724 472.516L104.263 240.01H196.45ZM480.879 240.01L372.299 492.014L263.718 240.01H480.879ZM283.172 180.034L372.08 76.8855L460.934 180.034H283.172ZM547.874 240.01H641.81L447.108 474.365L547.874 240.01ZM634.542 180.034H541.645L438.529 60.0288H529.677L634.542 180.034ZM217.051 60.0288H306.069L202.625 180.034H109.181L217.051 60.0288Z' fill='url(%23paint0_linear_2983_47950)'/%3E%3Cdefs%3E%3ClinearGradient id='paint0_linear_2983_47950' x1='0.000871949' y1='545.407' x2='715.106' y2='206.178' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0.0104167' stop-color='%23AB3AD2'/%3E%3Cstop offset='0.5' stop-color='%23863AD2'/%3E%3Cstop offset='1' stop-color='%235936E4'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: bottom 30% right -5%;
      top: -60px;
      padding: 60px 0;
      margin-bottom: -140px;
      &--premium-promo-page {
        padding-bottom: 100px;
        margin-bottom: -230px;
      }
    }
    @include lg-desktop {
      background-position: bottom 30% right 30%;
    }
  }
  &__content {
    @include desktop {
      max-width: 1120px;
      margin: auto;
      padding: 60px 0 120px 0;
    }
  }
  &__text {
    font-family: var(--font-regular);
    &-title {
      color: var(--white);
      font-weight: 700;
      margin-bottom: 40px;
      max-width: 620px;
      font-size: rem(32px);
      line-height: 38px;
      @include mobile {
        font-size: rem(54px);
        line-height: 66px;
      }
      &-enquiry {
        color: var(--purple-pale);
        text-shadow: 0px 0px 24px var(--black);
        margin-bottom: 10px;
        font-size: rem(16px);
        line-height: 23px;
        @include mobile {
          font-size: rem(24px);
          line-height: 32px;
        }
      }
    }
  }
  &__cta-button {
    text-decoration: none;
    font-size: rem(14px) !important;
    line-height: 20px;
    font-family: var(--font-medium) !important;
    font-weight: 500;
    &--hide {
      display: none !important;
    }
    @include desktop {
      height: 47px !important;
      width: 143px !important;
      font-size: rem(16px) !important;
    }
  }
}
</style>
